import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollDownOnClickDirective } from './scroll-down-on-click.directive';
import { ScrolledDownDirective } from './scrolled-down.directive';
import { ScrollIfDirective } from './scroll-if.directive';
import { ScrollableDirective } from './scrollable.directive';



@NgModule({
  declarations: [
    ScrollDownOnClickDirective,
    ScrolledDownDirective,
    ScrollIfDirective,
    ScrollableDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ScrollDownOnClickDirective,
    ScrolledDownDirective,
    ScrollIfDirective,
    ScrollableDirective,
  ]
})
export class ScrollModule { }
